module.exports = __webpack_public_path__ + "img/premium_dealer_logo_fr.1699635b.png";